// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import NonRefundable from '../_raw/service/icon_non_refundable.svg';
import withIconProps from '../withIconProps';

export default withIconProps(NonRefundable);
